import CountHoc from '@platform/react/hoc/pubsub/count'
import NameOrCount from 'ui/Element/List/Item/Cell/NameOrCount'

export default CountHoc(NameOrCount)
